import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import {RegisterForeignUnivPage} from '../../features/register/components/ForeginUnivPage';
import {withHandler} from '../../server/token/withHandler';
import {ScriptForGA} from '../../shared/components/ScriptForGA';

type Props = Record<string, unknown>;

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>({auth: 'optional'}, async (): Promise<GetServerSidePropsResult<Props>> => {
  return {
    props: {},
  };
});

const RegisterForeignUniv = () => {
  return (
    <>
      <RegisterForeignUnivPage />
      <ScriptForGA />
    </>
  );
};

export default RegisterForeignUniv;
